import { render, staticRenderFns } from "./MintOGVortex.vue?vue&type=template&id=1b3be89a&scoped=true&"
import script from "./MintOGVortex.vue?vue&type=script&lang=js&"
export * from "./MintOGVortex.vue?vue&type=script&lang=js&"
import style0 from "./MintOGVortex.vue?vue&type=style&index=0&id=1b3be89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3be89a",
  null
  
)

export default component.exports